import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as productActions from '../store/actions/product.actions';

@Injectable()
export class ProductOverviewResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(productActions.loadData());
    return of(true);
  }
}
